module.exports = __webpack_public_path__ + "static/media/aboutus-1.2e9912f2.png";